import {Component, OnInit, TemplateRef} from '@angular/core';
import {ApiService} from '@core/service/api.service';
import {WelfareProject} from '@core/class/welfare-project';
import {NbDialogService} from '@nebular/theme';
import {TableColumn} from '@core/components/welfy-table/table-column';
import {Observable} from 'rxjs';
import {Paginable} from '@core/components/welfy-table/model/paginable-interface';
import {Store} from '@ngrx/store';
import {AppState} from '@app/redux';
import {selectProjects} from '@app/welfy-plugin/welfy/calculator/redux';
import {loadProject, loadProjects} from '@app/welfy-plugin/welfy/calculator/redux/simulation.actions';
import {TableEvent} from '@core/components/welfy-table/model/table-event';

@Component({
  selector: 'app-projects-list',
  templateUrl: './projects-list.component.html',
  styleUrls: ['./projects-list.component.css']
})
export class ProjectsListComponent implements OnInit {

  projects: WelfareProject[];
  projects$: Observable<Paginable<WelfareProject>>;
  safeDeleteWorld = 'Conferma';
  safeDeleteWorldInput: string;
  safeWorldCorrected: boolean;
  loading: boolean;
  searchString: string;

  tableColumns: TableColumn[] = [
    {
      name: 'Nome',
      dataKey: 'name',
      isSortable: true,
    },
    {
      name: 'Data Creazione',
      dataKey: 'creationTime',
      isSortable: false,
    },
    {
      name: 'Data Ultima Modifica',
      dataKey: 'creationTime',
      isSortable: false,
    }
  ];

  private supervisor: boolean;

  constructor(private api: ApiService,
              private dialogService: NbDialogService,
              private state: Store<AppState>) {
  }

  get isSupervisor() {
    return this.supervisor;
  }

  ngOnInit() {
    this.loading = true;
    this.projects$ = this.state.select(selectProjects);
    this.loadProjects();
  }

  onRowSelected(item: WelfareProject) {
    this.state.dispatch(loadProject({id: item.id}))
  }

  checkSafeWorld() {
    if (this.safeDeleteWorldInput) {
      this.safeWorldCorrected = this.safeDeleteWorldInput.toLocaleUpperCase() === this.safeDeleteWorld.toUpperCase();
    }
  }

  deleteProject(selProject: WelfareProject, dialogRef: TemplateRef<any>) {
    // show safe dialog
    this.dialogService.open(dialogRef, {context: selProject}).onClose.subscribe(value => {
      if (value) {
        if (selProject.localCopy) {
          localStorage.removeItem('project_' + selProject.name);
          this.loadProjects();
        } else {
          this.api.deleteProject(selProject, 'welfy').subscribe(res => {
            // reload projects
            this.loadProjects();
          });
        }
      }
    });
  }

  searchProject() {
    if (this.searchString) {
      this.api.searchProject(this.searchString, 'welfy').subscribe(value => {
        this.projects = value;
      });
    } else {
      this.loadProjects();
    }
  }

  private loadProjects(tableEvent?: TableEvent) {
    this.state.dispatch(loadProjects({
      sort: tableEvent?.sort ? tableEvent.sort : null,
      pageEvent: tableEvent?.page ? tableEvent.page : null
    }));
  }
}
